import React from "react";
import { KeyFigure } from "../../keyfigures";
import classes from "./css/CountryReportMixer.module.css";
export default ({ locale,data, countryList, ...props }) => {
  return (
    <header className={classes.Header}>
      <div className={classes.HeaderContainer}>
        <div className={classes.HeaderItems}>
          <div className={classes.HeaderTitle}>
            <h3>{props.match.params.country}</h3>
          </div>          
          <KeyFigure data={data.keyFigures.slice(0, -1)} />        
        {console.log(locale)}
        <br/>
        {locale==="en" ? "Note: these data points refer to 2020" : "Remarque : ces données se réfèrent à l'année 2020"}
        <br/>
        {locale==="en" ? "Source: Africapolis calculation based on" : 'Source : calculs Africapolis basés sur le' } <b>{data.keyFigures[9]['value']} </b>
        </div>
      
      </div>
    </header>
  );
};
